module.exports = __webpack_public_path__ + "img/cotizacion_mobile.2ff5b63b.svg";